import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import { AuthorWatchButton } from '../../../Button';
import { getBlockBI } from '../../helpers';
import SeeAllLink from '../SeeAllLink';
import MoreByAuthor from '../MoreByAuthor';
import ContentByUser from '../ContentByUser';
import OwnedByUser from '../OwnedByUser';
import s from './SidebarBlockWrapper.scss';
const SidebarBlockWrapper = ({ deviation, block: { contentTitleType, contentType, seeAllType = 'seeall', seeAllUrl, titleType = 'plaintext', linkUrl, deviations: blockDeviations }, children, className, headerClassName, titleClassName, seeAllClassName, onSeeAllClick })=>{
    var _firstBlockDeviation_adoptable, _deviation_author, _deviation_author1;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const showSeeAllLink = !!seeAllUrl || !!onSeeAllClick;
    const { author } = deviation;
    const currentUser = useCurrentUser();
    const isDisplayingAnotherUsersMoreBy = !showSeeAllLink && titleType === 'more-by' && author && (author === null || author === void 0 ? void 0 : author.userId) !== currentUser.userId;
    const seeAllAlwaysVisible = showSeeAllLink && titleType === 'plaintext' && seeAllUrl;
    // precondition: the owner is the same for all deviations in the block
    const [firstBlockDeviation] = blockDeviations || [];
    const owner = firstBlockDeviation === null || firstBlockDeviation === void 0 ? void 0 : (_firstBlockDeviation_adoptable = firstBlockDeviation.adoptable) === null || _firstBlockDeviation_adoptable === void 0 ? void 0 : _firstBlockDeviation_adoptable.owner;
    const isNotOwner = (owner === null || owner === void 0 ? void 0 : owner.userId) !== currentUser.userId;
    const emphasisOnOwner = contentType === 'owned_by' && owner;
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: getBlockBI(contentType)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], seeAllAlwaysVisible && s['see-all-visible'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['block-header'], headerClassName)
    }, /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['block-title'], titleClassName)
    }, emphasisOnOwner ? /*#__PURE__*/ React.createElement(OwnedByUser, {
        owner: owner
    }) : titleType === 'more-by' && deviation.author ? /*#__PURE__*/ React.createElement(MoreByAuthor, {
        author: deviation.author,
        contentType: contentType
    }) : titleType === 'link' && linkUrl ? /*#__PURE__*/ React.createElement(ContentByUser, {
        contentTitle: t(`sidebar.blockTitle.${contentType}`, {
            author: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username
        }),
        contentUrl: linkUrl
    }) : t(`sidebar.blockTitle.${contentType}`, {
        author: (_deviation_author1 = deviation.author) === null || _deviation_author1 === void 0 ? void 0 : _deviation_author1.username
    })), showSeeAllLink && /*#__PURE__*/ React.createElement(SeeAllLink, {
        contentType: contentType,
        deviation: deviation,
        type: seeAllType,
        url: seeAllUrl,
        onClick: onSeeAllClick,
        className: classnames(s['see-all'], seeAllClassName)
    }), !isMobile && isDisplayingAnotherUsersMoreBy && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
        className: s['watch-button'],
        author: author
    }), !isMobile && emphasisOnOwner && isNotOwner && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
        className: s['watch-button'],
        author: owner
    })), children));
};
SidebarBlockWrapper.displayName = 'SidebarBlockWrapper';
export default SidebarBlockWrapper;
